// src/components/NetworkStatusIndicator.tsx

import React from 'react';
import { Box, Typography, Fade } from '@mui/material';
import { useSelector } from 'react-redux'; // Import useSelector
import { RootState } from '@store/store'; // Adjust path to your store types

export const NetworkStatusIndicator: React.FC = () => {
    // Read the network state directly from the Redux store
    const { isOnline, isWeak } = useSelector((state: RootState) => state.network);

    const isVisible = !isOnline || isWeak;
    const message = !isOnline ? "Offline" : "Weak Connection";
    const backgroundColor = !isOnline ? 'error.main' : 'warning.main';

    return (
        <Fade in={isVisible} timeout={300}>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '32px',
                    borderRadius: '16px',
                    backgroundColor: backgroundColor,
                    color: 'common.white',
                    boxShadow: 1,
                    px: 0.5,
                    sm: {
                        px: 2,
                        mr: 2,
                    },
                }}
            >
                <Typography
                    variant="caption"
                    sx={{
                        fontWeight: 'bold',
                        lineHeight: '1',
                        fontSize: '10px',
                        sm: {
                            fontSize: '0.75rem',
                            px: 2,
                        },
                    }}
                >
                    {message}
                </Typography>
            </Box>
        </Fade>
    );
};